import { render, staticRenderFns } from "./ContractorCard.vue?vue&type=template&id=06086d72"
import script from "./ContractorCard.vue?vue&type=script&lang=js"
export * from "./ContractorCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports